import {MapPoint} from "../MapPoint";
import {Brand} from "../../../types/Brand";

export function getListings(brand: Brand): () => Promise<GeoJSON.GeoJSON> {
    function getEncodeURI(path: string): string {
        let url = new URL(`https://unusedDomain${path}`)
        if (window.location.href.indexOf('origin=') !== -1) {
            let origin = window.location.href.substring(window.location.href.indexOf('origin=')+7)
            if (origin.indexOf("&") !== -1) {
                origin = origin.substring(0, origin.indexOf("&"));
            }
            url.searchParams.set("origin", origin);
        }
        url.searchParams.set("search-url", encodeURI(window.location.href));

        return url.pathname + url.search;
    }

    return () => fetch(getEncodeURI(`/api/${brand.toLowerCase()}/listings`))
        .then(response => response.json())
        .catch(error => console.error('Error fetching listings:', error));
}

export function getDetail(id: string, brand: Brand): Promise<MapPoint> {
    return fetch(`/api/${brand.toLowerCase()}/listing/${id}`).then(res => res.json())
}
